module.exports = __webpack_public_path__ + "static/img/swiper2.af31115.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/swiper2.jpeg
// module id = jAUe
// module chunks = 0